import { render, staticRenderFns } from "./Tiny.vue?vue&type=template&id=741623c1"
import script from "./Tiny.vue?vue&type=script&lang=js"
export * from "./Tiny.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports